import React, { createContext, useContext, useState } from "react";

// Create context for synced user data
const SyncedUserContext = createContext(null);

// Hook to use synced user data
export const useSyncedUser = () => {
  const context = useContext(SyncedUserContext);
  if (!context) {
    throw new Error("useSyncedUser must be used within a SyncedUserProvider");
  }
  return context;
};

// Provider component
export const SyncedUserProvider = ({ children }) => {
  const [syncedUserData, setSyncedUserData] = useState(null);

  const updateSyncedUser = (userData) => {
    setSyncedUserData(userData);
  };

  return (
    <SyncedUserContext.Provider value={{ syncedUserData, updateSyncedUser }}>
      {children}
    </SyncedUserContext.Provider>
  );
};
